import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { cookiesToTransform } from '../../constants';
import type { RemoveQueryParameterCallback, SetQueryParameterCallback } from '../../types';
import {
  debug,
  removeQueryParameter as removeQueryParameterHistoryApi,
  ensureQueryParameter as setQueryParameterHistoryApi,
} from '../../utils';

export interface CookieToUrlParams {
  removeQueryParameter: RemoveQueryParameterCallback;

  setQueryParameter: SetQueryParameterCallback;
}

/**
 * Reads cookie and transforms them into url - if found
 */
export const useCookieToUrl = (parameters?: CookieToUrlParams) => {
  useEffect(() => {
    const removeQueryParameter = parameters?.removeQueryParameter ?? removeQueryParameterHistoryApi;
    const setQueryParameter = parameters?.setQueryParameter ?? setQueryParameterHistoryApi;

    let foundPrev = false;

    for (const cookieInfo of cookiesToTransform) {
      const {
        cookie: cookieName,
        queryParam: queryParamName,
        stopIfFound,
        stopIfFoundPrev,
        removeIfNotFound,
      } = cookieInfo;
      const cookieValue = Cookies.get(cookieName);
      const stop = stopIfFoundPrev && foundPrev;

      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- eslint rule conflict - there is no way how to correctly satisfy eslint
      if (!cookieValue?.length) {
        if (removeIfNotFound) {
          removeQueryParameter(queryParamName);
        }

        debug(`Cookie value under the name of '${cookieName}' was not found!`);

        foundPrev = false;

        // stop if we should stop prematurely
        if (stop) {
          break;
        }
        continue;
      }

      // Ensure that query parameter is present and with correct value
      setQueryParameter(queryParamName, cookieValue);

      foundPrev = true;

      if (stopIfFound ?? stop) {
        break;
      }
    }
  }, [parameters?.removeQueryParameter, parameters?.setQueryParameter]);
};
